function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useState } from "react";
import styled from "styled-components";
import { parseIncompletePhoneNumber, formatIncompletePhoneNumber, getCountryCallingCode, AsYouType } from "libphonenumber-js/mobile";
import { FlexBox, Icon } from "../../";
import { Input } from "../";
import { CountrySelector } from "../CountrySelector";
import { countryList } from "./countryList";
export const CountryPhone = ({
  value,
  onChange,
  removeSelectedCountryLabel = false,
  onValidate,
  ...props
}) => {
  const updatedCountryList = countryList.map(country => ({ ...country,
    image: `https://flagcdn.com/w160/${country.id}.png`
  }));
  const [country, setCountry] = useState(updatedCountryList[0]);
  const [countryOpen, setCountryOpen] = useState(false);
  const [userChosenCountry, setUserChosenCountry] = useState(false);
  const selectedCountry = country.id.toUpperCase();
  const countryCode = getCountryCallingCode(selectedCountry);

  const format = value => {
    return formatIncompletePhoneNumber(value, selectedCountry);
  };

  let incomingValue = value;
  const asYouType = new AsYouType(selectedCountry);
  asYouType.input(value);
  const phoneNumber = asYouType?.getNumber();

  if (!!phoneNumber?.number) {
    incomingValue = phoneNumber?.format(selectedCountry === "US" ? "NATIONAL" : "INTERNATIONAL");
  }

  if (phoneNumber?.isValid()) {
    !!onValidate && onValidate(true);
  } else {
    !!onValidate && onValidate(false);
  }

  const detectedCountry = phoneNumber?.country;

  if (!!detectedCountry && !userChosenCountry) {
    if (detectedCountry !== selectedCountry) {
      let newCountry = updatedCountryList.find(({
        id
      }) => id === detectedCountry.toLowerCase());
      setCountry(newCountry);
    }
  }

  const handleChange = event => {
    let newValue = parseIncompletePhoneNumber(event);

    if (newValue === incomingValue) {
      if (format(newValue).indexOf(event) === 0) {
        newValue = newValue.slice(0, -1);
      }
    }

    let inputText = new AsYouType(selectedCountry);
    inputText.input(newValue);
    let phoneNumber = inputText?.getNumber();

    if (phoneNumber?.isValid()) {
      !!onValidate && onValidate(true);
    } else {
      !!onValidate && onValidate(false);
    }

    if (!!phoneNumber?.number) {
      newValue = phoneNumber?.number;
    }

    onChange(newValue, {
      countryCode
    });
  };

  const placeholder = selectedCountry === "US" ? "(000) 000-0000" : `+${countryCode} 000000000000`;

  const handleFocus = () => {
    if (value === "" && selectedCountry !== "US") {
      onChange(`+${countryCode}`, {
        countryCode
      });
    }
  };

  const handleBlur = () => {
    if (value === `+${countryCode}` && selectedCountry !== "US") {
      onChange("", {
        countryCode: ""
      });
    }
  };

  const handleCountryChange = c => {
    const getCountryCode = getCountryCallingCode(c.value.toUpperCase());
    const thisCountryCode = `+${getCountryCode}`;

    if (value.slice(0, countryCode.length + 1) !== thisCountryCode) {
      const newValue = value.replace(`+${countryCode}`, thisCountryCode);
      onChange(newValue, {
        countryCode: getCountryCode
      });
    }

    setCountry(c);
    setUserChosenCountry(true);
  };

  const removedCountryLabel = { ...country,
    value: ""
  };
  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(CountrySelectorStyle, {
    selected: !!removeSelectedCountryLabel ? removedCountryLabel : country,
    onChange: handleCountryChange,
    options: updatedCountryList,
    onOpen: setCountryOpen,
    isOpen: countryOpen,
    flagOnly: removeSelectedCountryLabel,
    country: true
  }), /*#__PURE__*/React.createElement(StyledInput, _extends({
    value: format(incomingValue),
    onChange: handleChange,
    autoComplete: "tel",
    type: "tel",
    leftIcon: /*#__PURE__*/React.createElement(Icon, {
      form: true,
      name: "Phone"
    }),
    placeholder: placeholder,
    isOpen: countryOpen,
    onFocus: handleFocus,
    onBlur: handleBlur
  }, props)));
};
const StyledInput = styled(Input)`
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: ${props => props.isOpen ? 0 : "4px"};
`;
const CountrySelectorStyle = styled(CountrySelector)`
  align-items: center;
  border-left: 1px solid ${props => props.theme.palette.gray.primary};
  border-right: none;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-top-left-radius: 4px;
  border-bottom-left-radius: ${props => props.isOpen ? 0 : "4px"};
  display: flex;
  flex-direction: row;
  flex-shrink: 0;
  justify-content: center;
  padding: 0;
  & > svg {
    margin-left: 15px;
    position: relative;
    top: inherit;
    right: inherit;
  }
  ${props => props.flagOnly && `
    width: 64px;
    svg {
      margin-left: 0;
    }
  `}
`;
const Container = styled(FlexBox)`
  position: relative;
`;